import { Award, Calendar, QrCode, Star, TrendingUp } from "lucide-react";
import React from "react";

const PhoneMockup = () => {
  return (
    <div className="relative">
      {/* Phone Frame */}
      <div className="relative w-80 h-[600px] mx-auto">
        {/* Phone Shadow */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900 rounded-[3rem] shadow-2xl transform rotate-3"></div>

        {/* Phone Body */}
        <div className="relative w-full h-full bg-gradient-to-br from-gray-900 to-gray-800 rounded-[3rem] p-2 shadow-2xl">
          {/* Screen */}
          <div className="w-full h-full bg-gradient-to-br from-blue-50 to-purple-50 rounded-[2.5rem] overflow-hidden relative">
            {/* Status Bar */}
            <div className="flex justify-between items-center px-6 pt-4 pb-2">
              <div className="text-black font-semibold text-sm">9:41</div>
              <div className="flex items-center space-x-1">
                <div className="w-4 h-2 bg-black rounded-sm"></div>
                <div className="w-6 h-3 border border-black rounded-sm">
                  <div className="w-4 h-2 bg-black rounded-sm m-0.5"></div>
                </div>
              </div>
            </div>

            {/* App Header */}
            <div className="px-6 py-4">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg flex items-center justify-center">
                  <QrCode className="h-4 w-4 text-white" />
                </div>
                <span className="text-lg font-bold text-gray-900">
                  e-Tampon
                </span>
              </div>

              <div className="bg-white rounded-2xl p-4 shadow-lg">
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <h3 className="font-bold text-gray-900">Marie Mbarga</h3>
                    <p className="text-sm text-gray-600">Parent - 4ème A</p>
                  </div>
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  </div>
                </div>

                <div className="text-center mb-4">
                  <div className="text-2xl font-black text-gray-900">150</div>
                  <div className="text-sm text-gray-600">Points totaux</div>
                </div>
              </div>
            </div>

            {/* Stats Cards */}
            <div className="px-6 space-y-3">
              <div className="bg-white rounded-xl p-3 shadow-sm">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-blue-500 rounded-lg flex items-center justify-center">
                      <Star className="h-3 w-3 text-white" />
                    </div>
                    <span className="text-sm font-medium text-gray-900">
                      Points
                    </span>
                  </div>
                  <span className="text-sm font-bold text-blue-600">150</span>
                </div>
              </div>

              <div className="bg-white rounded-xl p-3 shadow-sm">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-purple-500 rounded-lg flex items-center justify-center">
                      <Award className="h-3 w-3 text-white" />
                    </div>
                    <span className="text-sm font-medium text-gray-900">
                      Niveau
                    </span>
                  </div>
                  <span className="text-sm font-bold text-purple-600">
                    Argent
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-xl p-3 shadow-sm">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-green-500 rounded-lg flex items-center justify-center">
                      <Calendar className="h-3 w-3 text-white" />
                    </div>
                    <span className="text-sm font-medium text-gray-900">
                      Tampons
                    </span>
                  </div>
                  <span className="text-sm font-bold text-green-600">7/10</span>
                </div>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="px-6 mt-4">
              <div className="bg-white rounded-xl p-4 shadow-sm">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-gray-900">
                    Progression
                  </span>
                  <span className="text-sm font-bold text-blue-600">70%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-gradient-to-r from-blue-500 to-purple-500 h-2 rounded-full"
                    style={{ width: "70%" }}
                  ></div>
                </div>
                <p className="text-xs text-gray-600 mt-2">
                  Prochaine récompense: Certificat
                </p>
              </div>
            </div>

            {/* Recent Activity */}
            <div className="px-6 mt-4">
              <div className="bg-white rounded-xl p-4 shadow-sm">
                <h4 className="font-semibold text-gray-900 mb-3">
                  Activités récentes
                </h4>
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      <div className="w-4 h-4 bg-green-500 rounded-full"></div>
                      <span className="text-xs text-gray-700">
                        Réunion parents
                      </span>
                    </div>
                    <span className="text-xs font-bold text-green-600">
                      +10 pts
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      <div className="w-4 h-4 bg-blue-500 rounded-full"></div>
                      <span className="text-xs text-gray-700">
                        Sortie éducative
                      </span>
                    </div>
                    <span className="text-xs font-bold text-blue-600">
                      +15 pts
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* QR Code Button */}
            <div className="px-6 mt-4">
              <button className="w-full bg-gradient-to-r from-blue-500 to-purple-500 text-white py-3 rounded-xl font-semibold shadow-lg">
                <QrCode className="h-4 w-4 inline mr-2" />
                Mon QR Code
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute -top-4 -right-4 w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center shadow-lg animate-bounce">
        <TrendingUp className="h-4 w-4 text-white" />
      </div>

      <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center shadow-lg animate-pulse">
        <Star className="h-3 w-3 text-white" />
      </div>
    </div>
  );
};

export default PhoneMockup;
